import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { YouTubeFacade } from '@/components/ui/youtube-facade';

export function AboutPreview() {
  const { t } = useTranslation();

  return (
    <section className="py-10 md:py-14 bg-background overflow-hidden">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 items-center">
          {/* YouTube Video */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="relative rounded-lg overflow-hidden aspect-video shadow-lg">
              <YouTubeFacade videoId="Z6kGaWexxx0" title="Sampaoli Creazioni" />
            </div>
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground mb-4">
              {t('about.previewTitle')}
            </h2>
            <p className="font-body text-base text-muted-foreground leading-relaxed mb-6">
              {t('about.previewText')}
            </p>
            <Button variant="bronze" size="default" asChild>
              <Link to="/about" className="gap-2">
                {t('about.cta')}
                <ArrowRight className="w-4 h-4" />
              </Link>
            </Button>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
